(function () {

    'use strict';

    angular.module('iplusjs.validator.plz', [
        'iplusjs.fieldset',
        'iplusjs.utils.adresse'
    ])
        .directive('iplusjsPlzValidator', plzValidator);

    plzValidator.$inject = [
        '$q',
        '$log',
        '$timeout',
        'AdresseUtilsService'
    ];
    function plzValidator($q, $log, $timeout, AdresseUtilsService) {
        return {
            require: ['ngModel', '^?iplusjsFieldset'],
            scope: {
                loading: '=?'
            },
            link: linkFnc
        };

        function linkFnc($scope, $elem, $attrs, ctrls) {
            var $ngModel = ctrls[0],
                fieldsetCtrl = ctrls[1];

            if ($attrs.disabled || $scope.$eval($attrs.ngDisabled) || (fieldsetCtrl && fieldsetCtrl.disabled)) {
                return;
            }
            $ngModel.$asyncValidators.plz = function (value) {
                $scope.loading = true;

                return $q(function (resolve, reject) {
                    $log.debug('plzValidator $asyncValidators.plz');

                    return AdresseUtilsService.existsPlz(value).then(function () {
                        resolve();
                        $scope.loading = false;
                    }).catch(function () {
                        reject();
                        $scope.loading = false;
                    });
                });
            };
        }
    }
})();
